import {mapGenerator} from '../config/axios'
import pollutionAreas from "../reducers/map/pollutionAreas";

export const getPollutionArea = (map, callback) => {
    return mapGenerator.get('/pollutionAreas/'+ map)
        .then((response) => {
            if(response.status === 200) return response.data
            else return []
        })
        .then((polygon) => callback(polygon))
        .catch((err) => {
            console.warn(err)
            callback(null)
        })
}

export const deletePollutionArea = (map, callback) => {
    return mapGenerator.delete('/pollutionAreas/' + map)
        .then((response) => {
            callback(response.status)
        })
        .catch((error) => {
            console.error(error)
        })
}

export const storePollutionArea = (pollutionArea, callback) => {
    return mapGenerator.post('/pollutionAreas', pollutionArea)
        .then((response) => callback(response.status))
        .catch((err) => console.log(err))
}

export const updatePollutionArea = (id, pollutionArea, callback) => {
    return mapGenerator.put('/pollutionAreas/' + id, pollutionArea)
        .then((response) => {
            callback(response.status, response.data)
        })
        .catch((err) => {
            console.log(err)
            callback(500)
        });
}

export const generateBaseMap = (id, callback) => {
    return mapGenerator.delete(`pollutionAreas/${id}/deploy`)
        .then((response) => {
            callback(response.status, response.data)
        })
        .catch((err) => console.log(err, err.data));
}



// WEBPACK FOOTER //
// ./src/requests/pollutionArea.js